import { Link } from "react-router-dom";
import { brand } from "@mbb/config";
import AuthShell from "../components/AuthShell";

export default function AlmostThere() {
  return (
    <AuthShell
      eyebrow="Almost there"
      title="one last step."
      intro={
        <>
          Your account is set up. The last thing left is your{" "}
          {brand.membershipPriceLabel} membership — we're wiring up payment in
          the next release.
        </>
      }
    >
      <p
        style={{
          textAlign: "center",
          color: "var(--c-palm)",
          opacity: 0.85,
          fontSize: "0.95rem",
          lineHeight: 1.55,
          marginBottom: "1.25rem",
        }}
      >
        We'll email you the second the membership step opens. In the meantime,
        you can sign in to confirm your account works.
      </p>
      <p style={{ textAlign: "center" }}>
        <Link to="/login" className="btn btn--primary">
          Go to sign in
        </Link>
      </p>
    </AuthShell>
  );
}
